import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';
import { ScreenType } from 'src/app/enums/ScreenType';
import { visitorSummary } from 'src/app/models/table/visitorTable';

@Component({
  selector: 'app-visitor-summary',
  templateUrl: './visitor-summary.component.html',
  styleUrls: ['./visitor-summary.component.scss'],
})
export class VisitorSummaryComponent {
  @Input() set chartData(val: visitorSummary) {
    this.setChartData(val);
  }
  @Input() set screen(val: ScreenType) {
    this.screenInfo = val;
  }
  option: EChartsOption;
  screenInfo: ScreenType;
  ScreenType = ScreenType;

  constructor() {}
  private setChartData(data: visitorSummary) {
    this.option = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        bottom: '5%',
        left: 'center',
      },
      series: [
        {
          type: 'pie',
          radius: ['25%', '70%'],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2,
          },
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: false,
              fontSize: 40,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            {
              value: data.visited ? data.visitedVerified : 0,
              name: 'Visited-Verified',
            },
            {
              value: data.visited ? data.visitedUnverified : 0,
              name: 'Visited-Unverified',
            },
            {
              value: data.yetToVisit ? data.yetToVisitVerified : 0,
              name: 'Upcoming-Verified',
            },
            {
              value: data.yetToVisit ? data.yetToVisitUnverified : 0,
              name: 'Upcoming-Unverified',
            },
          ],
        },
      ],
    };
  }
}
